import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: localStorage.getItem("servicePaymentToken") || null,
  userInfo: JSON.parse(sessionStorage.getItem("userInfo") || "null"),
  phone: localStorage.getItem("phone") || null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.userInfo = action.payload.userInfo;
      state.phone = action.payload.userInfo?.phone;
      localStorage.setItem("servicePaymentToken", action.payload.token);
      sessionStorage.setItem("userInfo", JSON.stringify(action.payload.userInfo));
      localStorage.setItem("phone", action.payload.userInfo?.phone || "");
    },
    logout: (state) => {
      state.token = null;
      state.userInfo = null;
      state.phone = null;
      localStorage.removeItem("servicePaymentToken");
      sessionStorage.removeItem("userInfo");
      localStorage.removeItem("phone");
    },
  },
});

export const { login, logout } = authSlice.actions;

export const selectAuth = (state) => state.auth;

export default authSlice.reducer;
